import { Box } from '@indoqa/style-system';
import * as React from 'react';
import { withUIETheme } from '../uietheme/withUIETheme';
import { scrollbarStyles } from './scrollbarStyles';
const ContentPanel = ({ children, uieTheme }) => {
    const style = {
        boxSizing: 'border-box',
        backgroundColor: uieTheme.colors.bgContent,
        overflow: 'auto',
        ...scrollbarStyles(uieTheme),
    };
    return (React.createElement(Box, { fullWidth: true, fullHeight: true, style: style }, children));
};
export default withUIETheme(ContentPanel);
//# sourceMappingURL=ContentPanel.js.map